import { render, staticRenderFns } from "./tlifiulcont.vue?vue&type=template&id=f7e94c80&scoped=true&"
import script from "./tlifiulcont.vue?vue&type=script&lang=js&"
export * from "./tlifiulcont.vue?vue&type=script&lang=js&"
import style0 from "./tlifiulcont.vue?vue&type=style&index=0&id=f7e94c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e94c80",
  null
  
)

export default component.exports